import { Component, HostListener, inject } from '@angular/core';
import { COMMON_MODULES } from '@src/app/core/constants';
import { SharedDataService } from '@src/app/core/services/shared-data.service';
interface Testimonial {
  quote: string;
  body: string;
  authorName: string;
  authorRole: string;
  avatarUrl: string;
}

@Component({
  selector: 'app-mini-env-testimonials',
  imports: [...COMMON_MODULES],
  templateUrl: './mini-env-testimonials.component.html',
  styleUrl: './mini-env-testimonials.component.scss'
})
export class MiniEnvTestimonialsComponent {

  sharedDataService = inject(SharedDataService);

  testimonials: Testimonial[] = [
    {
      quote: '"I don’t postpone care anymore—it’s just too fast and easy."',
      body: '“I used to delay things until they got worse. Now I deal with them early without hesitation.” – A happy customer',
      authorName: 'Emily Parker',
      authorRole: 'Small Business Owner',
      avatarUrl: this.sharedDataService.miniEnvPath + 'images/avatar-placeholder.png' 
    },
    {
      quote: '“A lot less mental load than before.”',
      body: '“I don’t have to plan or stress about healthcare decisions anymore. It’s just simpler now.” – A happy customer',
      authorName: 'Emily Parker',
      authorRole: 'Small Business Owner',
      avatarUrl: this.sharedDataService.miniEnvPath + 'jets-pizza/client1.png'
    },
    {
      quote: '“It removes a lot of the usual frustration”',
      body: '“Getting healthcare used to be frustrating. This has taken away most of that for me.” – A happy customer',
      authorName: 'Emily Parker',
      authorRole: 'Small Business Owner',
      avatarUrl: this.sharedDataService.miniEnvPath + 'jets-pizza/client2.png'
    },
    {
      quote: '“I feel more proactive about my health”',
      body: '“Instead of reacting when things get bad, I’m actually staying ahead of issues now.” – A happy customer',
      authorName: 'Emily Parker',
      authorRole: 'Small Business Owner',
      avatarUrl: this.sharedDataService.miniEnvPath + 'images/avatar-placeholder.png'
    },
    {
      quote: '“I don’t hesitate anymore when something feels off”',
      body: '“If I notice something unusual, I just book an appointment instead of worrying about it for days.” – A happy customer',
      authorName: 'Emily Parker',
      authorRole: 'Small Business Owner',
      avatarUrl: this.sharedDataService.miniEnvPath + 'images/avatar-placeholder.png'
    },
    //     {
    //   quote: '“Simple, transparent, and stress-free.”',
    //   body: 'Finding providers and paying directly is simple and transparent. This is how healthcare should work.',
    //   authorName: 'Emily Parker',
    //   authorRole: 'Small Business Owner',
    //   avatarUrl: this.sharedDataService.miniEnvPath + 'jets-pizza/client3.png'
    // },
    {
      quote: '“Quick access makes a big difference”',
      body: '“When I need help, I don’t have to wait long or figure out where to go. That part alone is huge.” – A happy customer',
      authorName: 'Emily Parker',
      authorRole: 'Small Business Owner',
      avatarUrl: this.sharedDataService.miniEnvPath + 'jets-pizza/client4.png'
    },
    {
      quote: '“It makes getting care feel normal again”',
      body: '“I used to treat doctor visits like a big task. Now it feels like something routine and manageable.” – A happy customer',
      authorName: 'Emily Parker',
      authorRole: 'Small Business Owner',
      avatarUrl: this.sharedDataService.miniEnvPath + 'images/avatar-placeholder.png'
    },
    {
      quote: '“It’s been useful in small everyday issues too”',
      body: '“It’s not just for big problems. Even small concerns are easier to deal with now.” – A happy customer',
      authorName: 'Emily Parker',
      authorRole: 'Small Business Owner',
      avatarUrl: this.sharedDataService.miniEnvPath + 'images/avatar-placeholder.png'
    },
    {
      quote: '“A total game-changer for healthcare access.”',
      body: 'Finding providers and paying directly is simple and transparent. This is how healthcare should work.',
      authorName: 'Emily Parker',
      authorRole: 'Small Business Owner',
      avatarUrl: this.sharedDataService.miniEnvPath + 'images/avatar-placeholder.png'
    }
  ];

  // Add 8+ items to your array here to see the 2-row grid fill out properly

  currentIndex = 0;
  visibleColumns = 1;
  rows = 1;
  touchStartX = 0;
  touchEndX = 0;

  ngOnInit() {
    this.updateLayout();
  }

  @HostListener('window:resize')
  onResize() {
    this.updateLayout();
  }

  updateLayout() {
    const isDesktop = window.innerWidth >= 768;
    this.rows = isDesktop ? 2 : 1;
    // Estimate visible columns based on 380px width to prevent over-scrolling into empty space
    this.visibleColumns = isDesktop ? Math.floor(window.innerWidth / 400) : 1; 

    if (this.currentIndex > this.maxIndex()) {
      this.currentIndex = this.maxIndex();
    }
  }

  onTouchStart(event: TouchEvent) {
    this.touchStartX = event.touches[0].clientX;
  }

  onTouchMove(event: TouchEvent) {
    this.touchEndX = event.touches[0].clientX;
  }

  onTouchEnd() {
    const deltaX = this.touchEndX - this.touchStartX;
    if (deltaX > 50) {
      this.goToSlide(Math.max(0, this.currentIndex - 1));
    }
    else if (deltaX < -50) {
      this.goToSlide(Math.min(this.maxIndex(), this.currentIndex + 1));
    }
  }

  get totalColumns(): number {
    return Math.ceil(this.testimonials.length / this.rows);
  }

  maxIndex(): number {
    // Stop sliding when the last column is fully visible
    return Math.max(0, this.totalColumns - this.visibleColumns);
  }

  get dots(): number[] {
    return Array(this.maxIndex() + 1).fill(0).map((x, i) => i);
  }

  goToSlide(index: number) {
    this.currentIndex = index;
  }
}
